// extracted by mini-css-extract-plugin
export default {"alert":"useLimit24Hour-module--alert--GY71M","disabled":"useLimit24Hour-module--disabled--EM0ix","remainingTime":"useLimit24Hour-module--remaining-time--0FqkG"};